import { useContext } from 'react';
import { VersionInfoContext } from '../../VersionInfoStorage';
const useVersionInfoLazy = ()=>useContext(VersionInfoContext)?.versionInfo;
export default useVersionInfoLazy;
